export default function lists (Restangular) {
  'ngInject'
  return Restangular.all('list')
}
